module.exports = __webpack_public_path__ + "static/img/7.2945c575.jpg";